const nextAction = (title, onDone, props) => ({
  title,
  enabled: () => true,
  execute: context => {
    onDone();
    return context;
  },
  ...props
});

export default nextAction;
